<!--模板界面-->
<template>
	<div>
		<p class="bigTitle">告警类型</p>
		<vchart style="height: calc(100% - 68px);margin-top: 19px;" themes="UbiquitousOverviewChartSkin" ref='vchart'></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						right:0,
						bottom:0,
						textStyle:{
							color:"whtie"
						}
					},
					series: [{
						name: '占比',
						type: 'pie',
						radius: ['40%', '80%'],
						data: []
					}]
				}
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart.setData(this.options)
			this.initData()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			initData() {
				var list = []
				list.push({
					name: "处理中",
					value: 60
				})
				list.push({
					name: "未处理",
					value: 15
				})
				list.push({
					name: "已处理",
					value: 25
				})
				this.options.series[0].data = list
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: left;
		margin-left: 26px;
		margin-top: 15px;
		margin-bottom: 20px;
	}
</style>
